import {Button} from "@material-ui/core";

const ActivationConfirmStepAction = ({onClick}) => {
    return (
        <Button color="primary"
                variant="contained"
                onClick={() => onClick()}
                style={{alignSelf:'flex-end'}}>
            Chiudi
        </Button>
    )
}

export default ActivationConfirmStepAction;
